package org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.create_floor


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.home.options.restaurant_manager.restaurant_project.Room

@Serializable
data class CreateFloor(
    @SerialName("id")
    val id: String?,
    @SerialName("number")
    val number: Int?,
    @SerialName("objectType")
    val objectType: String?,
    @SerialName("projectId")
    val projectId: String?,
//    @SerialName("rooms")
//    val rooms: List<Room?>?,
    @SerialName("__typename")
    val typename: String?
)